import { AxiosInstance } from 'axios'

export default (api: AxiosInstance) => ({
  async requestOTPByCID(cid: string, socialPlatformId: string, force = false) {
    const result = await api.post('/customer/otp', { cid, socialPlatformId, force })
    return result.data
  },
  async verifyOTP(otp: string, reference: string) {
    const result = await api.put('/customer/otp', { otp, reference })
    return result.data
  },
})
